import { useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { getHelpConfig } from './HelpConfig.service';

export function useHelpConfig() {
  const query = useQuery(['help-config'], () => getHelpConfig());

  useServiceError(query.error);

  return query;
}
